import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const TopServicesHorizontalBars = ({ data }) => {
  const { isDark } = useTheme();
  // Filter out unknown services and take top 5
const parseValue = (val) => {
  if (typeof val === 'number') return val;

  if (!val) return 0;

  const num = parseFloat(String(val).replace(/[^\d.-]/g, ''));
  return isNaN(num) ? 0 : num;
};

const normalizedData = Array.isArray(data)
  ? data.map((d) => {
      // already normalized
      if (d.name && d.value !== undefined) {
        return {
          name: d.name,
          value: parseValue(d.value),
          formatted: d.formatted
        };
      }

      // backend raw format
      const metric = d.metric || {};

      const name =
        metric.log_group ||
        metric.cloudwatch_log_group ||
        metric.service_name ||
        metric.service ||
        (metric.s3_bucket ? `s3://${metric.s3_bucket}` : null) ||
        (metric.bucket ? `s3://${metric.bucket}` : null) ||
        metric.source;

      return {
        name,
        value: parseValue(d.value?.[1]),
      };
    }).filter(d => {
      if (!d.name) return false;

      const n = d.name.trim().toLowerCase();

      return (
        n !== 'unknown' &&
        n !== 'unknown_service' &&
        n !== 'error'
      );
    })
  : [];

const topServices = normalizedData
  .sort((a, b) => b.value - a.value)
  .slice(0, 5);
  
  // Calculate total for percentages
  const totalVolume = topServices.reduce((sum, service) => sum + (service.value || 0), 0);
  
  const servicesWithPercent = topServices.map(service => ({
    ...service,
    percentage: totalVolume > 0 ? ((service.value / totalVolume) * 100) : 0
  }));

  const COLORS = ['#ef4444', '#06b6d4', '#22c55e', '#a855f7', '#eab308'];

  if (servicesWithPercent.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        padding: 24,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '13px', fontWeight: 500, marginBottom: '4px', color: isDark ? '#e6edf3' : '#0f172a' }}>
          No log volume data yet.
        </div>
        <div style={{ fontSize: '12px', color: isDark ? '#8b949e' : '#64748b', marginBottom: '14px' }}>
          Connect log sources to begin ingestion. This chart will show service distribution once data is flowing.
        </div>
        <Link to="/logs">
          <Button type="primary" size="small">Connect log sources</Button>
        </Link>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {servicesWithPercent.map((service, index) => (
        <div key={service.name} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            fontSize: '11px',
            color: isDark ? '#adbac7' : '#64748b',
            width: '90px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {service.name}
          </span>
          <div style={{
            flex: 1,
            height: '6px',
            background: isDark ? '#30363d' : '#f1f5f9',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div
              style={{
                height: '100%',
                width: `${service.percentage}%`,
                background: COLORS[index % COLORS.length],
                borderRadius: '3px',
                transition: 'width 0.3s ease'
              }}
            />
          </div>
          <span style={{
            fontSize: '11px',
            color: isDark ? '#8b949e' : '#94a3b8',
            minWidth: '55px',
            textAlign: 'right'
          }}>
            {service.formatted || `${(service.value || 0).toFixed(4)} MB`}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TopServicesHorizontalBars;